import styled from 'styled-components';
import MUITabs from '@material-ui/core/Tabs';

const StyledMUITabs = styled(MUITabs)`
  background-color: transparent;
  min-height: 40px;

  & .MuiTabs-indicator {
    background-color: transparent;
    border: 2px solid ${props => props.theme.colors.brand.secondary};
    border-radius: 20px;
    box-sizing: border-box;
    height: 100%;
  }
`;


export default StyledMUITabs;
